export default __webpack_public_path__ + "static/neue-haas-grotesk-display-65-medium-e3bc899e1b135763632779991e0804f8.woff2";